import { useCallback } from 'react';
import { TServerSendRequest } from 'js/hooks/socket/types';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetGamblingSessionLimits = () => {
    const send = useGenericSend();

    return useCallback(async () => {
        const { data } = await send<TServerSendRequest, Types.IGetSessionLimitsResponseData>({
            ID: 35899,
            responses: [35900, 35901],
            errorLevel: 1,
            description: 'Get gambling session limits'
        });

        return data;
    }, [send]);
};
